"use client";

import { DocumentList } from "@/components/dashboard/document-list";
import { Button } from "@/components/tailwind/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/tailwind/ui/dialog";
import { Input } from "@/components/tailwind/ui/input";
import { useFolderContext } from "@/context/FolderContext";
import { starterDocument } from "@/lib/StarterDocument";
import { getAuth } from "firebase/auth";
import { Timestamp, arrayUnion, collection, doc, getFirestore, setDoc, updateDoc } from "firebase/firestore";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function DashboardPage() {
  const [viewMode, setViewMode] = useState<"list" | "grid">("list");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [docName, setDocName] = useState("");
  const router = useRouter();
  const { activeFolderId } = useFolderContext();

  const handleCreateDocument = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user || !docName.trim() || !activeFolderId) return;

    const db = getFirestore();
    const newDocRef = doc(collection(db, "documents"));
    const docId = newDocRef.id;

    const newDoc = {
      type: "doc",
      name: docName.trim(),
      ownerId: user.uid,
      content: starterDocument.content,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    };

    await setDoc(newDocRef, newDoc);
    await updateDoc(doc(db, "userCollections", user.uid), {
      documents: arrayUnion(docId),
    });
    await updateDoc(doc(db, "folders", activeFolderId), {
      documents: arrayUnion(docId),
    });

    setIsDialogOpen(false);
    setDocName(""); // Reset input
    router.push(`/document/${docId}`);
  };

  return (
    <div className="flex h-screen bg-background">
      <main className="flex-1 overflow-auto">
        <div className="p-6 space-y-8">
          {/* Create New Section */}
          <div>
            <h2 className="text-xl font-semibold mb-4">Create new</h2>
            <div className="flex space-x-4">
              <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
                <DialogTrigger asChild>
                  <button type="button">
                    <div className="w-32 h-32 bg-secondary border border-accent shadow-sm rounded-md hover:shadow-md transition-shadow" />
                    <p className="mt-2 text-sm font-medium">Blank notebook</p>
                  </button>
                </DialogTrigger>
                <DialogContent className="max-w-sm">
                  <DialogHeader>
                    <DialogTitle>Name your document</DialogTitle>
                  </DialogHeader>
                  <Input
                    placeholder="e.g. CSE 312 Notes"
                    value={docName}
                    onChange={(e) => setDocName(e.target.value)}
                    className="mt-4"
                  />
                  <Button className="mt-4 w-full" onClick={handleCreateDocument}>
                    Create
                  </Button>
                </DialogContent>
              </Dialog>
            </div>
          </div>

          {/* Tabs + Search + Docs */}
          <div className="space-y-4">
            <DocumentList />
          </div>
        </div>
      </main>
    </div>
  );
}
